import React from 'react';
import PropTypes from 'prop-types';

import SearchResult from './SearchResult';

const SearchResults = ({
    searched, items, notFoundMessage, readMore,
}) => (
    <div className="card-list">
        {items.length === 0 && searched && (
            <div className="card">
                <div className="card__content">
                    <h2>{notFoundMessage}</h2>
                </div>
            </div>
        )}
        {items.map((item, index) =>
            (<SearchResult
                // eslint-disable-next-line react/no-array-index-key
                key={`${item.document.title}-${index}`}
                item={item}
                readMore={readMore}
                isLast={index === items.length - 1}
            />))}
    </div>
);

SearchResults.propTypes = {
    searched: PropTypes.bool.isRequired,
    items: PropTypes.arrayOf(PropTypes.shape({}).isRequired).isRequired,
    notFoundMessage: PropTypes.string.isRequired,
    readMore: PropTypes.string.isRequired,
};

export default SearchResults;
